export default {"src":"/frontend-static/_next/static/media/heart-filled.932e5093.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};